<template>
  <div>
    <div class="container">
      <div class="row justify-content-around" >
        <div class="col-lg-4">
          <browser-track :options="rnaOptions"
          checkboxTitle="Choose RNA-signal track to visualize in browser" 
          dropDownText="  RNA-signal Tracks  " 
          ref="rnaTrack"/>
          <browser-track-color :options="colorOptions" ref="trackColor"/>
          <browser-track-height ref="trackHeight"/>
        </div>
        <div class="col-lg-4">
          <div class="row m-4 justify-content-center">
            <b-button pill size="lg" variant="outline-primary" @click="postData"><b-icon icon="camera"></b-icon> Visualize</b-button>
          </div>
          <div class="row m-5 justify-content-center">
            <b-button pill size="lg" variant="outline-info" :href="browserUrl" target="_blank" :disabled="!showBrowser"><b-icon icon="fullscreen"></b-icon> Full Screen</b-button>
          </div>
          <div class="row m-4 justify-content-center">
            <b-button pill size="lg" variant="outline-secondary" @click="hideBrowser" :disabled="!showBrowser"><b-icon icon="fullscreen-exit"></b-icon> Hide</b-button>
          </div>
        </div>
      </div>
    </div>
    <br>
    <div class="container-fluid">
      <div class="row justify-content-center"> 
        <div class="col-xl-10 shadow p-3 mb-5 bg-white rounded" v-if="showBrowser">
          <b-embed :src="browserUrl" allowfullscreen></b-embed>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getBrowserUrl } from '@/api/api.js'
import BrowserTrack from './Form/BrowserTrack.vue'
import BrowserTrackHeight from './Form/BrowserTrackHeight.vue'
import BrowserTrackColor from './Form/BrowserTrackColor.vue'

import colorOptions from './Form/colorOptions.json'
import rnaOptions from './Form/rnaOptions.json'

export default {
  components: { BrowserTrack, BrowserTrackHeight, BrowserTrackColor },
  data() {
    return {
      selectedHeight: null,
      selectedColor: null,
      selectedRNA: null,
      rnaOptions,
      colorOptions,
      browserUrl: null,
      showBrowser: false
    }
  },
  methods: {
    postData() {
      // Force to refresh
      this.showBrowser = false
      // Return ';' joined string to back server
      this.selectedRNA = this.$refs.rnaTrack.selected.join(';')
      this.selectedHeight = this.$refs.trackHeight.selected
      this.selectedColor = this.$refs.trackColor.selected
      getBrowserUrl(this.selectedHeight, this.selectedRNA, this.selectedColor).then(
        response => {
          this.browserUrl = response.data.href
          this.$store.commit('updateURL', this.browserUrl)
          this.showBrowser = true
        }
      )
    },
    hideBrowser() {
      this.showBrowser = false
    }
  },

}
</script>

<style>

</style>